
import { DashboardRevenuePerMonthCompareData } from "@/utils/dashboard/dashboard-revenue-per-month-compare-data";
import Vue from "vue";
import AppHumanFilterListEdit from "@/components/models/HumanFilterListEdit.vue";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { TranslateResult } from "vue-i18n";
import { BrowseService } from "@/services/browse-service";
import { Model, getModel } from "@/utils/models/model";
import { Browse } from "@/models/browse";

export default Vue.extend({
	data(){
		return {
			browse: undefined as undefined | Browse,
			data: new DashboardRevenuePerMonthCompareData(),
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		title: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		},
	},
	computed: {
		model():Model | undefined{
			if (!this.browse) return undefined;
			return getModel(this.browse.Table);
		}
	},
	watch: {
		item: {
			immediate: true,
			handler(){
				if (!this.item.Data) {
					this.data = new DashboardRevenuePerMonthCompareData();
					return;
				}
				this.data = new DashboardRevenuePerMonthCompareData(this.item.Data.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.item.Data = this.data;
			this.$emit("confirm", this.item);
			this.close();
		},
	},
	async created() {
		this.browse = BrowseService.browses.find(b=>b.ID == 6);
	},
	components: {
		AppHumanFilterListEdit
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
